<template>
<div id="">
  <v-container fluid class="pt-0 ">
    <v-row>
      <v-col cols="12" class="pt-0 ">
        <v-card style="min-height:85vh" class="admin_secondary">
          <v-card-title class="secondary white--text">
            Dashboard
            <v-spacer></v-spacer>
            <v-btn icon dark @click="load" :loading="loading">
              <v-icon>fa-sync</v-icon>
            </v-btn>
          </v-card-title>
          <v-container class=" white--text">
            <v-row align="center" justify="space-between">

              <v-col cols="12" md="6" lg="4" xl="3">
                <v-select label="Show" hide-details dark outlined :items="['Last 6 hours','Last 24 hours','Last 30 days','This month','This year','Last 7 days']" v-model="spark_date"></v-select>
              </v-col>

            </v-row>
          </v-container>

          <v-container class="admin_secondary white--text">
            <v-row justify="center">
              <v-col cols="12" lg="4">
                <spark-tile label="Users joined" color="green" :values="users_joined" :labels="spark_date_labels"></spark-tile>
              </v-col>
              <v-col cols="12" lg="4">
                <spark-tile label="Projects Created" color="primary" :values="projects_created" :labels="spark_date_labels"></spark-tile>
              </v-col>
              <v-col cols="12" lg="4">
                <spark-tile label="Contests Created" color="cool_purple" :values="contests_created" :labels="spark_date_labels"></spark-tile>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

      </v-col>
    </v-row>
  </v-container>

</div>
</template>
<script>
import sparktile from "./sparktile"
export default {
  name: "",
  components: {
    sparkTile: sparktile
  },
  data: () => ({
    spark_date: 'Last 6 hours',
    users_joined: [1, 0, 2, 4, 0, 0],
    projects_created: [1, 0, 2, 4, 0, 0],
    contests_created: [1, 0, 2, 4, 0, 0]
  }),
  computed: {
    spark_date_labels() {
      return [
        '1am',
        '2am',
        '3am',
        '4am',
        '5am',
        '6am'
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
